export default __webpack_public_path__ + "static/media/checkbox-empty-enabled.icon.312de9f8.svg";